import * as React from 'react';

export default function CreditCardLoadingPlaceholder() {
  return (
    <div className="loading-placeholder-content">
      <div className="bd-1 bd--offwhite bd-rounded ptb-1 plr-1 mb-1">
        <div className="placeholder-li mb-1 mt-1" />
        <div className="placeholder-li mb-1 mt-1" />
        <div className="placeholder-li mb-1 mt-1" />
        <div className="placeholder-li mb-1 mt-1" />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./javascripts/components/credit_cards/credit_card_loading_placeholder.jsx